const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

export const OMISE_PUBLIC_KEY = conf[env].OMISE_PUBLIC_KEY
export const identityNumberText = 'เลขบัตรประจำตัวประชาชน'
export const passportNumberText = 'เลขที่หนังสือเดินทาง'
export const DATE_FORMAT = 'DD/MM/YYYY'
export const PUBLIC_PAGE = ['tvilogin', 'tmblogin', 'index', 'callbacktvi', 'authlanding']

export const validationRule = {
  customerIdentity: {
    idCard: 'required|numeric|min:13|max:13',
    passport: 'required',
  },
  healthQuestion: 'required',
}

export const packagePlanType = {
  IPD: 'IPD',
  OPD_DELUXE: 'OPD(Deluxe)',
  OPD_STANDARD: 'OPD(Standard)',
  HIB: 'HIB',
  CANCER: 'Cancer',
  CI: 'CI',
}

export const PAYMENT_METHOD = {
  BPY: 'bpy',
  TMB: 'tmb',
  CCO: 'cco',
  QR: 'qr',
}
